import { Injectable } from '@angular/core';
import { Product } from '../models/product.model';
import { ApiService } from '../api.service';
import { isNull } from 'util';
import { GlobalService } from '../services/global.service';

@Injectable({
  providedIn: 'root'
})
export class wishlistService {

  products: Product[];


  constructor(private apiService: ApiService, public global: GlobalService) {

   }


  async productList(): Promise<Product[]> {
    console.log('Cambio en el servicio: ' + this.global.cambio);
    if (this.products == null || this.products.length == 0 || this.global.cambio == true)
    {
      this.global.cambio = false;
      this.products = await this.apiService.getArticulos('/api/wishlist');
      console.log('Lista de deseaos cargada: ' + this.products);
    }
    return this.products;
  }
}
